import { useEffect, useState } from "react";
import { Copy, Check, ExternalLink, Link2 } from "lucide-react";
import { toast } from "sonner";
import api, { errMsg, fmtDate } from "../../lib/api";
import { PageHeader, StatusBadge, LoadingRows, EmptyState } from "../../components/Shared";
import { Button } from "../../components/ui/button";

export default function CreatorLinks() {
  const [links, setLinks] = useState(null);
  const [copied, setCopied] = useState("");

  useEffect(() => {
    api.get("/vid/creator/links").then((r) => setLinks(r.data.links)).catch((e) => { toast.error(errMsg(e)); setLinks([]); });
  }, []);

  const copy = async (code) => {
    const url = `${process.env.REACT_APP_BACKEND_URL}/api/vid/r/${code}`;
    try { await navigator.clipboard.writeText(url); setCopied(code); setTimeout(() => setCopied(""), 2000); toast.success("Affiliate link copied!"); }
    catch { toast.info(url); }
  };

  return (
    <div data-testid="creator-links-page">
      <PageHeader title="Affiliate Links" subtitle="Your tracking links — clicks & conversions update automatically" testid="links-title" />
      {!links ? <LoadingRows rows={3} /> : links.length === 0 ? (
        <EmptyState title="No affiliate links yet" body="Browse Affiliate Products & Services and generate your first tracking link." icon={Link2} />
      ) : (
        <div className="space-y-3">
          {links.map((l) => (
            <div key={l.id} data-testid={`link-row-${l.id}`} className="bg-card border border-border rounded-xl p-4 flex flex-wrap items-center gap-4">
              <div className="flex-1 min-w-[220px]">
                <p className="font-display font-bold text-sm">{l.offer?.name || "Offer removed"}</p>
                <code className="text-[11px] text-muted-foreground font-mono">/api/vid/r/{l.code}</code>
                <p className="text-[11px] text-muted-foreground mt-1">Since {fmtDate(l.created_at)} · {l.offer ? (l.offer.commission_type === "pct" ? `${l.offer.commission_value}% commission` : `₹${l.offer.commission_value} commission`) : ""}</p>
              </div>
              <div className="flex items-center gap-5 text-center">
                <div><p className="font-display font-extrabold text-lg" data-testid={`link-clicks-${l.id}`}>{l.clicks}</p><p className="text-[10px] font-bold uppercase text-muted-foreground">Clicks</p></div>
                <div><p className="font-display font-extrabold text-lg text-emerald-600" data-testid={`link-convs-${l.id}`}>{l.conversions}</p><p className="text-[10px] font-bold uppercase text-muted-foreground">Sales</p></div>
                {l.offer && <StatusBadge status={l.offer.active ? "active" : "paused"} />}
              </div>
              <div className="flex gap-2">
                <Button size="sm" data-testid={`link-copy-${l.id}`} onClick={() => copy(l.code)} className="rounded-full font-bold gradient-bg text-white border-0">
                  {copied === l.code ? <Check className="h-3.5 w-3.5 mr-1" /> : <Copy className="h-3.5 w-3.5 mr-1" />}{copied === l.code ? "Copied" : "Copy Link"}
                </Button>
                {l.offer && (
                  <Button size="sm" variant="outline" data-testid={`link-view-${l.id}`} onClick={() => window.open(l.offer.target_url, "_blank")} className="rounded-full font-bold">
                    <ExternalLink className="h-3.5 w-3.5" />
                  </Button>)}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
